import React from 'react';

export type Possession = 'home' | 'away' | null;

interface PossessionToggleProps {
    value: Possession;
    homeLabel: string;
    awayLabel: string;
    onChange: (side: 'home' | 'away') => void;
}

/**
 * Binary possession control. Starts unset (no side highlighted) until the
 * operator picks who won the swim-off; from then on it toggles home/away.
 */
const PossessionToggle: React.FC<PossessionToggleProps> = ({
    value,
    homeLabel,
    awayLabel,
    onChange,
}) => (
    <div className="m-poss">
        <button
            type="button"
            className={`m-poss__seg m-poss__seg--home${value === 'home' ? ' is-active' : ''}`}
            onClick={(): void => onChange('home')}
        >
            {homeLabel}
        </button>
        <span className="m-poss__label">POSSESSION</span>
        <button
            type="button"
            className={`m-poss__seg m-poss__seg--away${value === 'away' ? ' is-active' : ''}`}
            onClick={(): void => onChange('away')}
        >
            {awayLabel}
        </button>
    </div>
);

export default PossessionToggle;
